import React from 'react';
import { Repeat } from 'sushiweb/Icons';
import { Tooltip, CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { viewText, headPhone } from '../../../../images/images';
import { WFHCall } from '../../../commons';
import { UserAlternativeNumberCallClickEvent } from '../../../../analytics/call-logging/events';

export const AlternateNumber = ({
  number = 'xxxxxxxxxx',
  numberInfo = null,
  calledTo,
  orderId = null,
  userId = null,
  isWFH = false,
  isNewUser = false,
  unmaskNumber = () => {},
  regenerateNumber = () => {},
  alternateContactName = 'Receiver Contact Number',
  cartId = null,
}) => {
  return (
    <div>
      <span className='icon iconMarginR'>
        <img src={headPhone} alt='' />
      </span>
      <Tooltip
        position='bottom'
        title={
          <React.Fragment>
            {numberInfo ? (
              <CopyText
                orderId={orderId}
                title={numberInfo.phone}
                masking={false}
                calledTo={calledTo}
              />
            ) : (
              <div className='masked tw-mr-2'>
                {number}
                <span
                  className='viewIcon icon iconMarginL'
                  onClick={() => unmaskNumber(false)}
                >
                  <img src={viewText} alt='' />
                </span>
              </div>
            )}
          </React.Fragment>
        }
        label={alternateContactName}
      />
      {numberInfo && numberInfo.show_reload_button && (
        <Tooltip
          position='bottom'
          border={false}
          title={
            <div
              className='pointer'
              onClick={() =>
                regenerateNumber(numberInfo.masked_number_popup, false)
              }
            >
              <Repeat size={18} color={grey.z500} />
            </div>
          }
          label='Renew Masked Number'
        />
      )}
      {isWFH ? (
        <WFHCall
          orderId={orderId}
          userId={userId}
          isNewUser={isNewUser}
          pos='top'
          isAltContact={true}
          altContactMissing={true}
          isUser={true}
          calledTo={calledTo}
          sendJumboEvent={true}
          jumboEventFunc={UserAlternativeNumberCallClickEvent}
          JumboEventProperties={{
            is_new_ui: false,
          }}
          cartId={cartId}
        />
      ) : null}
    </div>
  );
};
